/*!
 * Front side js file
 */

"use strict";

document.addEventListener('DOMContentLoaded', () => {
    jQuery(document).on('change', '.variation_id', function (e) {
        if (document.querySelector('.woocommerce-variation-add-to-cart')) {
            document.querySelector('.woocommerce-variation-add-to-cart').style.display = 'none';
        }

        if (!jQuery(this).val()) {
            return;
        }

        var variationId = parseInt(jQuery(this).val());
        let variations = [];

        if (document.querySelector('.variations select')) {
            document.querySelectorAll('.variations select').forEach((variation) => {
                if (variation.value === '') {
                    count++;
                } else {
                    variations.push(variation.value);
                }
            });

        }

        fetch(wkwcspal_front_object.ajaxurl, {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            }),
            body: "action=wkwcspal_remove_variation_add_to_cart_button&nonce=" + wkwcspal_front_object.admin_ajax_nonce + "&variation_id=" + variationId + "&post_id=" + wkwcspal_front_object.post_id + "&variations=" + variations,
        })
            .then(response => response.ok ? response.json() : false).then((response) => {
                if (response && response.hide_price) {
                    document.querySelector('.woocommerce-variation.single_variation').innerHTML = response.button;
                } else {
                    document.querySelector('.woocommerce-variation-add-to-cart').style.display = 'block';
                }
            });
    });

    if (document.querySelector('.variations select')) {
        document.querySelector('.variations select').addEventListener('change', () => {
            if (document.querySelector('.woocommerce-variation-add-to-cart')) {
                document.querySelector('.woocommerce-variation-add-to-cart').style.display = 'none';
            }

            setTimeout(() => {
                const variationId = document.querySelector('.variation_id') ? document.querySelector('.variation_id').value : '';
                let variations = [], count = 0;

                if (document.querySelector('.variations select')) {
                    document.querySelectorAll('.variations select').forEach((variation) => {
                        if (variation.value === '') {
                            count++;
                        } else {
                            variations.push(variation.value);
                        }
                    });
                }

                if (count === 0) {
                    fetch(wkwcspal_front_object.ajaxurl, {
                        method: "post",
                        headers: new Headers({
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Accept": "application/json"
                        }),
                        body: "action=wkwcspal_remove_variation_add_to_cart_button&nonce=" + wkwcspal_front_object.admin_ajax_nonce + "&variation_id=" + variationId + "&post_id=" + wkwcspal_front_object.post_id + "&variations=" + variations,
                    })
                        .then(response => response.ok ? response.json() : false).then((response) => {
                            if (response && response.hide_price) {
                                document.querySelector('.woocommerce-variation.single_variation').innerHTML = response.button;
                            } else {
                                document.querySelector('.woocommerce-variation-add-to-cart').style.display = 'block';
                            }
                        });
                }
            }, 20);
        });
    }

    // Record frontend price hides once per session.
    if (jQuery('.wkwcspal-login-link, .wkwcspal-blurred-price').length > 0) {
        if (!document.cookie.split('; ').find(row => row.startsWith('wkwcspal_price_hide_logged='))) {
            // Set session cookie so we don't record again in this session.
            document.cookie = "wkwcspal_price_hide_logged=1; path=/; max-age=86400; SameSite=Lax";

            jQuery.ajax({
                type: 'POST',
                url: wkwcspal_front_object.ajaxurl,
                data: {
                    action: 'wkwcspal_record_price_hide',
                    nonce: wkwcspal_front_object.admin_ajax_nonce
                }
            });
        }
    }

    // Record frontend login clicks.
    jQuery(document).on('click', '.wkwcspal-login-link', function () {
        jQuery.ajax({
            type: 'POST',
            url: wkwcspal_front_object.ajaxurl,
            data: {
                action: 'wkwcspal_record_login_click',
                nonce: wkwcspal_front_object.admin_ajax_nonce
            }
        });
    });

    // Ajax Login & Inquiry Modal Logic
    if (wkwcspal_front_object.is_ajax_login || wkwcspal_front_object.is_price_inquiry) {
        const modal = document.getElementById('wkwcspal-login-modal');
        const closeBtn = document.querySelector('.wkwcspal-modal-close');
        const showRegister = document.getElementById('wkwcspal-show-register');
        const showLogin = document.getElementById('wkwcspal-show-login');
        const loginForm = document.getElementById('wkwcspal-login-form');
        const registerForm = document.getElementById('wkwcspal-register-form');
        const inquiryForm = document.getElementById('wkwcspal-inquiry-form');
        const inquiryShowLogin = document.getElementById('wkwcspal-inquiry-show-login');
        const modalTitle = document.getElementById('wkwcspal-modal-title');
        const modalMsg = document.getElementById('wkwcspal-modal-msg');

        // Toggle Modal for Login
        jQuery(document).on('click', '.wkwcspal-ajax-login-trigger', function (e) {
            e.preventDefault();
            if (modal) {
                modal.classList.add('is-open');
                if (loginForm) loginForm.style.display = 'block';
                if (registerForm) registerForm.style.display = 'none';
                if (inquiryForm) inquiryForm.style.display = 'none';
                if (modalTitle) modalTitle.innerText = 'Sign In';
            }
        });

        // Toggle Modal for Inquiry
        jQuery(document).on('click', '.wkwcspal-inquiry-trigger', function (e) {
            e.preventDefault();
            const productId = this.getAttribute('data-product_id');
            const productTitle = this.getAttribute('data-product_title');

            if (modal && inquiryForm) {
                inquiryForm.querySelector('#wkwcspal-inquiry-product-id').value = productId;
                inquiryForm.querySelector('#wkwcspal-inquiry-product-name-input').value = productTitle;
                const nameSpan = inquiryForm.querySelector('#wkwcspal-inquiry-product-name');
                if (nameSpan) {
                    nameSpan.textContent = productTitle;
                }

                modal.classList.add('is-open');
                if (loginForm) loginForm.style.display = 'none';
                if (registerForm) registerForm.style.display = 'none';
                inquiryForm.style.display = 'block';
                if (modalTitle) modalTitle.innerText = 'Request a Quote';
            }
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('is-open');
                modalMsg.className = 'wkwcspal-message';
                modalMsg.innerHTML = '';
            });
        }

        window.addEventListener('click', (e) => {
            if (e.target == modal) {
                modal.classList.remove('is-open');
            }
        });

        // Switch Forms
        if (showRegister) {
            showRegister.addEventListener('click', (e) => {
                e.preventDefault();
                if (loginForm) loginForm.style.display = 'none';
                if (inquiryForm) inquiryForm.style.display = 'none';
                if (registerForm) registerForm.style.display = 'block';
                if (modalTitle) modalTitle.innerText = 'Create Account';
            });
        }

        if (showLogin) {
            showLogin.addEventListener('click', (e) => {
                e.preventDefault();
                if (registerForm) registerForm.style.display = 'none';
                if (inquiryForm) inquiryForm.style.display = 'none';
                if (loginForm) loginForm.style.display = 'block';
                if (modalTitle) modalTitle.innerText = 'Sign In';
            });
        }

        if (inquiryShowLogin) {
            inquiryShowLogin.addEventListener('click', (e) => {
                e.preventDefault();
                if (inquiryForm) inquiryForm.style.display = 'none';
                if (registerForm) registerForm.style.display = 'none';
                if (loginForm) loginForm.style.display = 'block';
                if (modalTitle) modalTitle.innerText = 'Sign In';
            });
        }

        // Handle Login
        if (loginForm) {
            loginForm.addEventListener('submit', (e) => {
                e.preventDefault();
                const btn = loginForm.querySelector('.wkwcspal-submit-btn');
                const loader = loginForm.querySelector('.wkwcspal-loader');

                btn.style.display = 'none';
                loader.style.display = 'block';
                modalMsg.className = 'wkwcspal-message';

                jQuery.ajax({
                    type: 'POST',
                    url: wkwcspal_front_object.ajaxurl,
                    data: jQuery(loginForm).serialize() + '&action=wkwcspal_ajax_login&security=' + jQuery('#wkwcspal_login_nonce').val(),
                    dataType: 'json',
                    success: function (res) {
                        console.log('Login AJAX Success:', res);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        if (res && res.success) {
                            modalMsg.className = 'wkwcspal-message success';
                            modalMsg.innerHTML = (res.data && res.data.message) ? res.data.message : 'Success!';
                            location.reload();
                        } else {
                            modalMsg.className = 'wkwcspal-message error';
                            modalMsg.innerHTML = (res && res.data && res.data.message) ? res.data.message : 'An error occurred. Please try again.';
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error('Login AJAX Error:', textStatus, errorThrown, jqXHR.responseText);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        modalMsg.className = 'wkwcspal-message error';
                        modalMsg.innerHTML = 'Server error. Please try again later.';
                    }
                });
            });
        }

        // Handle Register
        if (registerForm) {
            registerForm.addEventListener('submit', (e) => {
                e.preventDefault();
                const btn = registerForm.querySelector('.wkwcspal-submit-btn');
                const loader = registerForm.querySelector('.wkwcspal-loader');

                btn.style.display = 'none';
                loader.style.display = 'block';
                modalMsg.className = 'wkwcspal-message';

                jQuery.ajax({
                    type: 'POST',
                    url: wkwcspal_front_object.ajaxurl,
                    data: jQuery(registerForm).serialize() + '&action=wkwcspal_ajax_register&security=' + jQuery('#wkwcspal_register_nonce').val(),
                    dataType: 'json',
                    success: function (res) {
                        console.log('Register AJAX Success:', res);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        if (res && res.success) {
                            modalMsg.className = 'wkwcspal-message success';
                            modalMsg.innerHTML = (res.data && res.data.message) ? res.data.message : 'Success!';
                            location.reload();
                        } else {
                            modalMsg.className = 'wkwcspal-message error';
                            modalMsg.innerHTML = (res && res.data && res.data.message) ? res.data.message : 'An error occurred. Please try again.';
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error('Register AJAX Error:', textStatus, errorThrown, jqXHR.responseText);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        modalMsg.className = 'wkwcspal-message error';
                        modalMsg.innerHTML = 'Server error. Please try again later.';
                    }
                });
            });
        }

        // Handle Inquiry Submission
        if (inquiryForm) {
            inquiryForm.addEventListener('submit', (e) => {
                e.preventDefault();
                const btn = inquiryForm.querySelector('.wkwcspal-submit-btn');
                const loader = inquiryForm.querySelector('.wkwcspal-loader');

                btn.style.display = 'none';
                loader.style.display = 'block';
                modalMsg.className = 'wkwcspal-message';

                jQuery.ajax({
                    type: 'POST',
                    url: wkwcspal_front_object.ajaxurl,
                    data: jQuery(inquiryForm).serialize() + '&action=wkwcspal_submit_inquiry&security=' + wkwcspal_front_object.inquiry_nonce,
                    dataType: 'json',
                    success: function (res) {
                        console.log('Inquiry AJAX Success:', res);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        if (res && res.success) {
                            modalMsg.className = 'wkwcspal-message success';
                            modalMsg.innerHTML = (res.data && res.data.message) ? res.data.message : 'Success!';
                            inquiryForm.reset();
                            setTimeout(() => {
                                modal.classList.remove('is-open');
                                modalMsg.className = 'wkwcspal-message';
                                modalMsg.innerHTML = '';
                            }, 2000);
                        } else {
                            modalMsg.className = 'wkwcspal-message error';
                            modalMsg.innerHTML = (res && res.data && res.data.message) ? res.data.message : 'An error occurred. Please try again.';
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error('Inquiry AJAX Error:', textStatus, errorThrown, jqXHR.responseText);
                        btn.style.display = 'block';
                        loader.style.display = 'none';
                        modalMsg.className = 'wkwcspal-message error';
                        modalMsg.innerHTML = 'Server error. Please try again later.';
                    }
                });
            });
        }
    }
});
